import React from "react";
import { getImgPath } from "../common/helper";

import {
  t,
  HEADING1,
  HEADING2,
  HEADING3,
  P1,
  P2,
  P3,
  P4,
  P5,
  LI1,
  LI2,
  LI3,
  LI4,
  LI5,
  LI6,
  LI7,
  LI8,
  LI9,
  LI10,
  P6,
  P7,
  P8,
  P9,
  P10,
} from "../../translations/AboutUs/PassengerSafety";

function PassengerSafety() {
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div className="a-large" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(HEADING1)}
      </div>
      <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HEADING2)}
      </div>
      <div className="a-normal" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(HEADING3)}
      </div>
      <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
        {t(P1)} <br />
        <br />
        {t(P2)}
        <br />
        <br />
        {t(P3)}
        <br />
        <br />
        {t(P4)}
        <br />
        <br />
        {t(P5)}
      </div>
      <ul style={{ margin: 0, padding: 0, marginLeft: 50 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI4)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI5)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI6)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI7)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI9)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(LI10)}</li>
      </ul>
      <div className="a-regular" style={{ fontWeight: 500, textAlign: "justify" }}>
        {t(P6)}
      </div>
      <div className="a-normal" style={{ fontSize: 16, fontWeight: 500, textAlign: "justify" }}>
        {t(P7)}
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 15,
        }}
      >
        <img src={getImgPath("/img/aboutus/img1.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img2.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img3.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img4.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img5.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img6.png")} alt="" />
        <div style={{ fontSize: 16, fontWeight: 500 }}>{t(P8)}</div>
        <img src={getImgPath("/img/aboutus/img7.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img8.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img9.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img10.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img11.png")} alt="" />
        <img src={getImgPath("/img/aboutus/img12.png")} alt="" />
      </div>
      <div className="a-normal" style={{ fontWeight: 500, textAlign: "justify" }}>
        {t(P9)}
      </div>
      <div className="a-regular" style={{ fontWeight: 400, textAlign: "justify" }}>
        {t(P10)}
      </div>
    </div>
  );
}

export default PassengerSafety;
